var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Category3",
                                        prop: "category3Code",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请选择",
                                          },
                                          model: {
                                            value:
                                              _vm.queryCondition.category3Code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "category3Code",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.category3Code",
                                          },
                                        },
                                        _vm._l(
                                          _vm.categoryList3,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.object,
                                                value: item.key,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Sponsor",
                                        prop: "sponsorName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.sponsorName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "sponsorName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.sponsorName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Farm Group",
                                        prop: "farmGroup",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.farmGroup,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "farmGroup",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.farmGroup",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "状态",
                                        prop: "farmGroupStatus",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请选择",
                                          },
                                          model: {
                                            value:
                                              _vm.queryCondition
                                                .farmGroupStatus,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "farmGroupStatus",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.farmGroupStatus",
                                          },
                                        },
                                        _vm._l(
                                          _vm.statusList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.object,
                                                value: item.key,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.RMC_FARMGROUP_ADD,
                      expression: "RMC_FARMGROUP_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.addFarmGroup },
                },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.RMC_FARMGROUP_DELETE,
                      expression: "RMC_FARMGROUP_DELETE",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.onDel },
                },
                [_vm._v("删除")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.RMC_FARMGROUP_SAVE,
                      expression: "RMC_FARMGROUP_SAVE",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.changeStatus(1)
                    },
                  },
                },
                [_vm._v("启用")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.RMC_FARMGROUP_SAVE,
                      expression: "RMC_FARMGROUP_SAVE",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.changeStatus(2)
                    },
                  },
                },
                [_vm._v("禁用")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.RMC_FARMGROUP_EXPORT,
                      expression: "RMC_FARMGROUP_EXPORT",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.exportData },
                },
                [_vm._v("导出")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.RMC_FARMGROUP_GEN_TASK,
                      expression: "RMC_FARMGROUP_GEN_TASK",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.generateTodoList },
                },
                [_vm._v("生成待办任务")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.RMC_FARMGROUP_DEL_TASK,
                      expression: "RMC_FARMGROUP_DEL_TASK",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.deleteTodoList },
                },
                [_vm._v("删除待办任务")]
              ),
            ],
            1
          ),
          _c(
            "ux-grid",
            {
              ref: "plxTable",
              attrs: {
                data: _vm.tableData,
                "max-height": "500",
                "show-overflow": "tooltip",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.selectionChange },
            },
            [
              _c("ux-table-column", {
                attrs: { align: "center", type: "checkbox", width: "80" },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Category3",
                  field: "category3Name",
                  width: "120",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Sponsor",
                  "min-width": "100",
                  field: "sponsorName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Farm Group",
                  "min-width": "120",
                  field: "farmGroup",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.goDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.farmGroup))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "状态",
                  "min-width": "100",
                  field: "farmGroupStatus",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "更新人",
                  "min-width": "120",
                  field: "updateName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "更新时间",
                  "min-width": "120",
                  field: "updateDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "关联数据",
                  "min-width": "120",
                  field: "createDate",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.examine(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "60%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "header-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "div",
                {
                  staticClass: "info_box_title",
                  staticStyle: {
                    "padding-left": "10px",
                    "box-sizing": "border-box",
                  },
                },
                [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "info_title" }, [
                    _vm._v("Farm Group关联数据查看"),
                  ]),
                ]
              ),
            ]
          ),
          _vm.dialogVisible
            ? _c(
                "ux-grid",
                {
                  ref: "plxTable",
                  attrs: {
                    data: _vm.dialogTable,
                    "max-height": "500",
                    "show-overflow": "tooltip",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "关联数据",
                      "min-width": "100",
                      field: "name",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "已有数据",
                      "min-width": "100",
                      field: "code",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "操作",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goPage(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3947196708
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.exportDialog, width: "30%" },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "header-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "div",
                {
                  staticClass: "info_box_title",
                  staticStyle: {
                    "padding-left": "10px",
                    "box-sizing": "border-box",
                  },
                },
                [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "info_title" }, [_vm._v("选择季度")]),
                ]
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                inline: true,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "年", prop: "year" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      disabled: _vm.isBool ? true : false,
                      "value-format": "yyyy",
                      type: "year",
                      placeholder: "选择年",
                    },
                    model: {
                      value: _vm.ruleForm.year,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "year", $$v)
                      },
                      expression: "ruleForm.year",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "季度", prop: "quarter" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        disabled: _vm.isBool ? true : false,
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.ruleForm.quarter,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "quarter", $$v)
                        },
                        expression: "ruleForm.quarter",
                      },
                    },
                    _vm._l(_vm.quarterList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.exportFarm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("导出")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.exportDialog = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }